module.exports = __webpack_public_path__ + "img/cj9100_center_002.74ab9c26.png";